const getters = {
  token: state => state.user.token,
  userName: state => state.user.userName,
  userInfo: state => state.user.userInfo,
  menus:state => state.user.menus
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js